module.exports = __webpack_public_path__ + "static/media/citizen-builders.60a64a45.png";